import React, { useEffect } from "react";



const FairPracticeCode: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const policySections = [
    {
      title: `${import.meta.env.VITE_COMPANY_NBFC} (Brand Name: ${import.meta.env.VITE_COMPANY_NAME})`,
      content: `Reviewed by Board of Directors
Approved on: 15 April 2025

BACKGROUND

The Reserve Bank of India ("RBI") has issued guidelines on Fair Practice Code for Non-Banking Finance Companies (NBFCs) vide Notification No. DNBS (PD) CC No. 80 / 03.10.042 / 2005-06 dated September 28, 2006 and amended from time to time, setting standards for fair business and corporate practices while dealing with customers.

${import.meta.env.VITE_COMPANY_NAME} adopts these guidelines and makes necessary modifications to this Code as required from time to time. The Company is committed to offering all financial products to eligible applicants without discrimination on grounds of race, caste, color, religion, sex, marital status, age, or disability.

The Fair Practice Code (FPC) outlines procedures for business transactions and ensures fair treatment of borrowers.`,
    },
    {
      title: "A. APPLICATIONS FOR LOANS AND THEIR PROCESSING",
      list: [
        "1. Borrower Communications: All borrower communications will be in the vernacular language or in a language understood by the borrower.",
        "2. Loan Application Forms: Loan application forms will include all necessary information impacting the borrower's interest, enabling informed decision-making. Forms will clearly list required documents.",
        "3. Application Acknowledgment: The Company shall provide an acknowledgment for all loan applications, indicating a timeframe within which a decision will be conveyed.",
      ],
    },
    {
      title: "B. LOAN APPRAISAL AND TERMS/CONDITIONS",
      list: [
        "1. Communication of Terms: The Company will communicate loan sanction details, including terms, conditions, annualized interest rate, and penal charges, in writing and in the language understood by the borrower.",
        "2. Documentation: The borrower's acceptance of terms and conditions will be retained. A copy of the loan agreement and all referenced documents will be furnished at the time of disbursement.",
      ],
    },
    {
      title: "C. DISBURSEMENT OF LOANS AND CHANGES IN TERMS",
      list: [
        "1. Changes to Terms: Any changes to terms, including interest rate, charges, or disbursement schedule, will be communicated in advance in the borrower's language. Changes will apply only prospectively.",
        "2. Loan Management: Loan recall or acceleration will align with the loan agreement. Securities will be released on repayment unless a legitimate lien exists. If so, the borrower will be informed with full particulars.",
      ],
    },
    {
      title: "D. RATE OF INTEREST",
      list: [
        "1. Interest Rate Determination: The Company will determine interest rates based on cost of funds, margin, and risk premium, with procedures for risk gradation.",
        "2. Transparency: Interest rate and rationale for variation among borrower categories will be disclosed in both application and sanction letter. Interest rate and gradation approach will be published on the Company website and updated as applicable.",
        "3. Annualized Terms: Interest will be expressed in annualized terms to ensure borrower clarity.",
      ],
    },
    {
      title: "E. GRIEVANCE REDRESSAL",
      list: [
        `1. Customer Care Department: Phone: ${import.meta.env.VITE_COMPANY_PHONE}, Email: ${import.meta.env.VITE_COMPANY_EMAIL}`,
        `2. Grievance Redressal Officer: Phone: ${import.meta.env.VITE_COMPANY_PHONE}, Email: ${import.meta.env.VITE_COMPANY_EMAIL}`,
        "3. RBI Contact: Officer-in-Charge, Department of Non-Banking Supervision, RBI, Delhi Regional Office, 6, Sansad Marg, New Delhi – 110001. Phone: +91-11-2371 4456 / 0538, +91-11-2375 2188, Email: dnbsnewdelhi@rbi.org.in",
      ],
      content: "Complaints will be addressed within one month. If unresolved, customers may contact RBI.",
    },
    {
      title: "F. GENERAL PROVISIONS",
      list: [
        "1. Borrower Affairs: The Company will avoid unnecessary interference in borrowers' affairs, except as per loan terms or newly disclosed information.",
        "2. Account Transfers: Borrowers requesting account transfers will receive a response within 21 days.",
        "3. Recovery Practices: Recovery practices will be conducted respectfully without harassment.",
        "4. Foreclosure Penalties: No foreclosure or prepayment penalties will be charged on floating rate loans to individual borrowers (non-business purposes).",
      ],
    },
    {
      title: "G. FORCE MAJEURE",
      content:
        "In extraordinary events, fulfillment of all commitments may not be possible. The Company shall make every effort to maintain service standards under such conditions.",
    },
    {
      title: "H. IMPLEMENTATION",
      content:
        "The implementation of the Fair Practice Code is the responsibility of the entire organization. It shall reflect through training, accountability, monitoring, audits, and effective use of technology. This Code shall be reviewed and updated periodically to enhance its relevance and value to borrowers.",
    },
    {
      title: "Place & Date",
      list: ["Place: New Delhi", "Date: 15 April 2025"],
    },
  ];

  return (
    <div className="min-h-screen bg-[#EFFFFD] font-['Inter',sans-serif] pt-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-[#2C3E50] mb-4">
            Fair Practice Code
          </h1>
          <p className="text-lg text-[#2C3E50]/80 max-w-3xl mx-auto">
            At{" "}
            <span className="font-semibold text-[#21A6B5]">
              {import.meta.env.VITE_COMPANY_NAME}
            </span>
            , operated by{" "}
            <span className="text-[#21A6B5]">
              {import.meta.env.VITE_COMPANY_NBFC}
            </span>
            , we are committed to upholding and practicing fairness, transparency,
            and responsibility in all customer dealings.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 space-y-8">
          {policySections.map((section, idx) => (
            <div key={idx} className="space-y-3">
              <h2 className="text-xl md:text-2xl font-bold text-[#2C3E50] border-b-2 border-[#21A6B5]/30 pb-2">
                {section.title}
              </h2>
              {section.content && (
                <p className="text-[#2C3E50]/80 text-base whitespace-pre-line leading-relaxed">
                  {section.content}
                </p>
              )}
              {section.list && (
                <ul className="list-disc list-outside ml-6 space-y-2 text-[#2C3E50]/80 text-base">
                  {section.list.map((li, i) => (
                    <li key={i} className="pl-1">{li}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
         
      </div>
    </div>
  );
};

export default FairPracticeCode;
